import { AdminModalHeaderProps } from './admin-modal-header-props';
import React from 'react';
import styled from 'styled-components';

type ComponentType = React.FunctionComponent<AdminModalHeaderProps>;

export const AdminModalHeader = styled.div<ComponentType>`
  padding: 0 1rem;
  /* margin-bottom: 1rem; */
`;
